module.exports = __webpack_public_path__ + "static/media/1_3.v1.bc0d3a85.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/1_3.v1.jpeg
// module id = 278
// module chunks = 0